<script setup>
import Card from './../Card.vue';
import Sheet from './../Sheet.vue';
import { formatDateString, formatWeekday } from './utils';

const props = defineProps({
    activeDay: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['handleStream']);

const handleShowStream = (latestContentstreamId) => {
    emit('handleStream', latestContentstreamId);
};
</script>

<template>
    <div :id="props.activeDay.date" class="py-6">
        <Card active>
            <template #header>
                <h3 class="text-lg font-semibold">Release: {{ formatWeekday(props.activeDay.date, true) }}: {{ formatDateString(props.activeDay.date) }}</h3>
            </template>

            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div v-for="event in props.activeDay?.items" :key="event.id" class="w-full">
                    <Sheet :flat="true" class="w-full">
                        <div class="grid grid-cols-[auto_3fr] gap-4 items-center">
                            <div class="flex">
                                <img :src="event.logo" class="h-12 w-12 object-cover rounded-full" />
                            </div>
                            <div class="flex flex-col gap-2">
                                <span class="font-bold">{{ event.name }}</span>

                                <span class="text-blue cursor-pointer flex items-center gap-1" @click="handleShowStream(event?.latest_contentstream)">
                                    {{ $t('plain_analysis') }}
                                    <i class="fi fi-rs-arrow-right text-xs mt-1"></i>
                                </span>
                            </div>
                        </div>
                    </Sheet>
                </div>
            </div>
        </Card>
    </div>
</template>
